export const STAGES = [
  { key: 'lead', label: 'Potansiyel', color: 'bg-gray-100 text-gray-700', border: 'border-gray-300' },
  { key: 'qualified', label: 'Nitelikli', color: 'bg-sky-100 text-sky-700', border: 'border-sky-300' },
  { key: 'proposal', label: 'Teklif', color: 'bg-indigo-100 text-indigo-700', border: 'border-indigo-300' },
  { key: 'negotiation', label: 'Pazarlık', color: 'bg-amber-100 text-amber-700', border: 'border-amber-300' },
  { key: 'won', label: 'Kazanıldı', color: 'bg-green-100 text-green-700', border: 'border-green-300' },
  { key: 'lost', label: 'Kaybedildi', color: 'bg-red-100 text-red-700', border: 'border-red-300' },
];

export const OPEN_STAGES = ['lead', 'qualified', 'proposal', 'negotiation'];

export const ACTIVITY_TYPES = [
  { key: 'note', label: 'Not', icon: '📝' },
  { key: 'call', label: 'Telefon', icon: '📞' },
  { key: 'meeting', label: 'Toplantı', icon: '🤝' },
  { key: 'email', label: 'E-posta', icon: '✉️' },
  { key: 'task', label: 'Görev', icon: '☑️' },
];

const SYSTEM_TYPE = { key: 'system', label: 'Sistem', icon: '⚙️' };

export const QUOTE_STATUSES = [
  { key: 'draft', label: 'Taslak', color: 'bg-gray-100 text-gray-600' },
  { key: 'sent', label: 'Gönderildi', color: 'bg-blue-100 text-blue-600' },
  { key: 'approved', label: 'Onaylandı', color: 'bg-green-100 text-green-600' },
  { key: 'rejected', label: 'Reddedildi', color: 'bg-red-100 text-red-600' },
];

export const stageInfo = (key) => STAGES.find(s => s.key === key) || { key, label: key, color: 'bg-gray-100 text-gray-700' };
export const activityTypeInfo = (key) => ACTIVITY_TYPES.find(t => t.key === key) || (key === 'system' ? SYSTEM_TYPE : { key, label: key, icon: '•' });
export const quoteStatusInfo = (key) => QUOTE_STATUSES.find(s => s.key === key) || { key, label: key, color: 'bg-gray-100 text-gray-600' };

export function StageBadge({ stage }) {
  const s = stageInfo(stage);
  return <span className={`text-xs px-2 py-1 rounded font-medium ${s.color}`}>{s.label}</span>;
}

export function QuoteStatusBadge({ status }) {
  const s = quoteStatusInfo(status);
  return <span className={`text-xs px-2 py-1 rounded font-medium ${s.color}`}>{s.label}</span>;
}

const CURRENCY_SYMBOLS = { USD: '$', EUR: '€', TRY: '₺' };

export function formatMoney(value, currency = 'USD') {
  const n = Number(value) || 0;
  return `${CURRENCY_SYMBOLS[currency] || ''}${n.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}${CURRENCY_SYMBOLS[currency] ? '' : ' ' + currency}`;
}

export function formatDate(value) {
  if (!value) return '-';
  const d = new Date(value.length === 10 ? value + 'T00:00:00' : value);
  return d.toLocaleDateString('tr-TR');
}

export function formatDateTime(value) {
  if (!value) return '-';
  return new Date(value).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' });
}

export function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function isOverdue(activity) {
  return !activity.is_done && activity.due_date && activity.due_date < todayStr();
}
